// import React, { createContext, useContext, useState } from 'react';
// import { WalletConnectModalSign, useConnect } from '@walletconnect/modal-sign-react';
// import { EthereumProvider } from '@walletconnect/ethereum-provider';
// import { ethers } from 'ethers';

// const WalletConnectContext = createContext();

// const WalletConnectComponent = ({ children }) => {
//   const projectId = '079e21e7569ef30abc034ba5abd8ff99';
//   const [session, setSession] = useState(null);
//   const [provider, setProvider] = useState(null);
//   const [signer, setSigner] = useState(null);
//   const [address, setAddress] = useState(null);

//   const { connect, disconnect, error } = useConnect({
//     requiredNamespaces: {
//       eip155: {
//         methods: ['eth_sendTransaction', 'personal_sign'],
//         chains: ['eip155:56'],
//         events: ['chainChanged', 'accountsChanged']
//       }
//     }
//   });

//   const connectWallet = async () => {
//     try {
//       let web3Provider;
//       if (window.ethereum) {
//         // Use MetaMask on desktop
//         web3Provider = new ethers.BrowserProvider(window.ethereum);
//         await web3Provider.send('eth_requestAccounts', []);
//       } else {
//         // Initialize WalletConnect provider
//         const walletConnectProvider = await EthereumProvider.init({
//           projectId,
//           showQrModal: true,
//           chains: [56],
//           metadata: {
//             name: 'ClusterC',
//             description: 'Be a part of the Gaming Revolution',
//             url: 'https://clusterc.io/',
//             icons: ['https://app.gemoo.com/share/image-annotation/661227102669619200?codeId=v6awolJXzkrLy&origin=imageurlgenerator&card=661227100345974784']
//           },
//           rpcMap: {
//             56: 'https://bsc-dataseed.binance.org/'
//           }
//         });

//         await walletConnectProvider.enable();
//         web3Provider = new ethers.BrowserProvider(walletConnectProvider);
//         setSession(walletConnectProvider.session);
//       }

//       const web3Signer = web3Provider.getSigner();
//       const userAddress = await web3Signer.getAddress();

//       setProvider(web3Provider);
//       setSigner(web3Signer);
//       setAddress(userAddress);

//       console.info('Connected using WalletConnect:', session);
//     } catch (err) {
//       console.error('Failed to connect wallet:', err);
//     }
//   };

//   const disconnectWallet = async () => {
//     try {
//       if (provider?.disconnect) {
//         await provider.disconnect();
//       }
//       setSession(null);
//       setProvider(null);
//       setSigner(null);
//       setAddress(null);
//     } catch (err) {
//       console.error('Failed to disconnect wallet:', err);
//     }
//   };

//   const signMessage = async (message) => {
//     if (!signer) {
//       throw new Error('Signer not available');
//     }
//     try {
//       const signature = await signer.signMessage(message);
//       console.log('Signed message:', signature);
//       return signature;
//     } catch (err) {
//       console.error('Failed to sign message:', err);
//       throw err;
//     }
//   };

//   return (
//     <WalletConnectContext.Provider value={{ session, connectWallet, disconnectWallet, provider, signer, address, signMessage }}>
//       {children}
//       <WalletConnectModalSign
//         projectId={projectId}
//         metadata={{
//           name: 'ClusterC',
//           description: 'Be a part of the Gaming Revolution',
//           url: 'https://clusterc.io/',
//           icons: ['https://app.gemoo.com/share/image-annotation/661227102669619200?codeId=v6awolJXzkrLy&origin=imageurlgenerator&card=661227100345974784'],
//         }}
//         modalOptions={{
//           explorer: {
//             recommendedWallets: [
//               { id: "metaMask", label: "MetaMask", installed: true },
//             ],
//           },
//         }}
//       />
//     </WalletConnectContext.Provider>
//   );
// };

// const useWalletConnect = () => useContext(WalletConnectContext);

// export { WalletConnectComponent, useWalletConnect };



// import React, { createContext, useContext, useState } from 'react';
// import { WagmiConfig } from 'wagmi';
// import { createWeb3Modal } from '@web3modal/wagmi/react';
// import { ethers } from 'ethers';
// import { AppKitProvider } from './config';  // Import from the config file

// const WalletConnectContext = createContext();

// const WalletConnectComponent = ({ children }) => {
//   const [provider, setProvider] = useState(null);
//   const [signer, setSigner] = useState(null);
//   const [address, setAddress] = useState(null);

//   const projectId = '079e21e7569ef30abc034ba5abd8ff99';

//   const connectWallet = async () => {
//     try {
//       const web3Modal = createWeb3Modal({
//         projectId,
//         metadata: {
//           name: 'ClusterC',
//           description: 'Be a part of the Gaming Revolution',
//           url: 'https://clusterc.io/',
//           icons: ['https://app.gemoo.com/share/image-annotation/661227102669619200?codeId=v6awolJXzkrLy&origin=imageurlgenerator&card=661227100345974784']
//         },
//         explorer: {
//           recommendedWallets: [
//             { id: "metaMask", label: "MetaMask", installed: true },
//           ],
//         }
//       });

//       const { ethereum } = await web3Modal.openModal();
//       const web3Provider = new ethers.BrowserProvider(ethereum);
//       const web3Signer = await web3Provider.getSigner();
//       const userAddress = await web3Signer.getAddress();

//       setProvider(web3Provider);
//       setSigner(web3Signer);
//       setAddress(userAddress);
//     } catch (err) {
//       console.error('Failed to connect wallet:', err);
//     }
//   };

//   const disconnectWallet = () => {
//     setProvider(null);
//     setSigner(null);
//     setAddress(null);
//   };

//   return (
//     <WalletConnectContext.Provider value={{ connectWallet, disconnectWallet, provider, signer, address }}>
//       <AppKitProvider>
//         {children}
//         <w3m-button></w3m-button>
//       </AppKitProvider>
//     </WalletConnectContext.Provider>
//   );
// };

// const useWalletConnect = () => useContext(WalletConnectContext);

// export { WalletConnectComponent, useWalletConnect };



import React, { createContext, useContext, useState } from 'react';
import { WagmiConfig } from 'wagmi';
import { createWeb3Modal } from '@web3modal/wagmi/react';
import { ethers } from 'ethers';
import { AppKitProvider } from './config';  // Import from the config file

const WalletConnectContext = createContext();

const WalletConnectComponent = ({ children }) => {
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);
  const [address, setAddress] = useState(null);

  const projectId = '079e21e7569ef30abc034ba5abd8ff99';

  const connectWallet = async () => {
    try {
      const web3Modal = createWeb3Modal({
        projectId,
        metadata: {
          name: 'ClusterC',
          description: 'Be a part of the Gaming Revolution',
          url: 'https://clusterc.io/',
          icons: ['https://app.gemoo.com/share/image-annotation/661227102669619200?codeId=v6awolJXzkrLy&origin=imageurlgenerator&card=661227100345974784']
        },
        explorer: {
          recommendedWallets: [
            { id: "metaMask", label: "MetaMask", installed: true },
          ],
        }
      });

      const { ethereum } = await web3Modal.openModal();
      const web3Provider = new ethers.BrowserProvider(ethereum);
      const web3Signer = await web3Provider.getSigner();
      const userAddress = await web3Signer.getAddress();

      setProvider(web3Provider);
      setSigner(web3Signer);
      setAddress(userAddress);
    } catch (err) {
      console.error('Failed to connect wallet:', err);
    }
  };

  const disconnectWallet = () => {
    setProvider(null);
    setSigner(null);
    setAddress(null);
  };

  return (
    <WalletConnectContext.Provider value={{ connectWallet, disconnectWallet, provider, signer, address }}>
      <AppKitProvider>
        {children}
      </AppKitProvider>
    </WalletConnectContext.Provider>
  );
};

const useWalletConnect = () => useContext(WalletConnectContext);

export { WalletConnectComponent, useWalletConnect };


